"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _debug = require("../utils/debug");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _index = _interopRequireDefault(require("axios/index"));
var _priceutils = require("../utils/priceutils");
var _i18n = require("../utils/i18n");
var _DiagnosticButton = _interopRequireDefault(require("./common/buttons/DiagnosticButton"));
var _pricingResource = require("../lib/pricingResource");
var _pricingResource2 = require("../constants/pricingResource");
var _ItemPriceDiagnosticModal = _interopRequireDefault(require("./ItemPriceDiagnostic/ItemPriceDiagnosticModal"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var ItemPriceDiagnostic = /*#__PURE__*/function (_Component) {
  _inherits(ItemPriceDiagnostic, _Component);
  var _super = _createSuper(ItemPriceDiagnostic);
  function ItemPriceDiagnostic(props) {
    var _this;
    _classCallCheck(this, ItemPriceDiagnostic);
    _this = _super.call(this, props);
    _this.mounted = true;
    _this.state = {
      checking: false,
      show: false,
      showFullJson: false,
      priceRepairInfo: null,
      hasPermissionForPriceRepair: false,
      priceExplorerHref: null
    };
    _this.pasLoader = props.pasLoader || new _pricingResource.PasLoader();
    return _this;
  }
  _createClass(ItemPriceDiagnostic, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.show && (this.props.priceType !== prevProps.priceType || this.props.itemId !== prevProps.itemId)) {
        this.loadData();
      }
    }
  }, {
    key: "loadData",
    value: function loadData() {
      var _this2 = this;
      if (!this.mounted) {
        return;
      }
      this.setState({
        checking: true
      }, function () {
        return _this2.getPriceInfo().then( /*#__PURE__*/function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
            var priceExplorerHref;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    if (!_this2.mounted) {
                      _context.next = 5;
                      break;
                    }
                    _context.next = 3;
                    return _this2.getPriceExplorerLink(data);
                  case 3:
                    priceExplorerHref = _context.sent;
                    _this2.setState({
                      priceInfo: data,
                      priceExplorerHref: priceExplorerHref
                    });
                  case 5:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }())["catch"](function (error) {
          (0, _debug.reportError)(error);
          if (_this2.mounted) {
            var priceInfo = {};
            if (error.isAxiosError) {
              priceInfo.networkError = {
                response: error.response
              };
            } else {
              priceInfo.genericError = error;
            }
            _this2.setState({
              priceInfo: priceInfo
            });
          }
        })["finally"]( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return _this2.verifyPriceCreatePermission();
                case 2:
                  _this2.setState({
                    checking: false,
                    show: true
                  });
                case 3:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        })));
      });
    }
  }, {
    key: "getPriceExplorerLink",
    value: function () {
      var _getPriceExplorerLink2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(priceInfo) {
        var _this$props, accessToken, priceType, inputs, _priceToDisplay$error, _priceToDisplay$error2, _priceToDisplay$error3, priceToDisplay, _errors$find, _errors$find$sourceEr, errors, source;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$props = this.props, accessToken = _this$props.accessToken, priceType = _this$props.priceType;
                if (!(priceType === _pricingResource2.priceTypes.shippingPrice)) {
                  _context3.next = 3;
                  break;
                }
                return _context3.abrupt("return", null);
              case 3:
                inputs = [];
                if (priceType === _pricingResource2.priceTypes.manufacturingCostTypeV1) {
                  priceToDisplay = priceInfo.priceToDisplay;
                  inputs = (priceToDisplay === null || priceToDisplay === void 0 ? void 0 : (_priceToDisplay$error = priceToDisplay.errors) === null || _priceToDisplay$error === void 0 ? void 0 : (_priceToDisplay$error2 = _priceToDisplay$error.find(function (error) {
                    return error.sourceError;
                  })) === null || _priceToDisplay$error2 === void 0 ? void 0 : (_priceToDisplay$error3 = _priceToDisplay$error2.sourceError) === null || _priceToDisplay$error3 === void 0 ? void 0 : _priceToDisplay$error3.inputs) || (priceToDisplay === null || priceToDisplay === void 0 ? void 0 : priceToDisplay.inputs);
                } else {
                  errors = priceInfo.errors, source = priceInfo.source;
                  inputs = (errors === null || errors === void 0 ? void 0 : (_errors$find = errors.find(function (error) {
                    return error.sourceError;
                  })) === null || _errors$find === void 0 ? void 0 : (_errors$find$sourceEr = _errors$find.sourceError) === null || _errors$find$sourceEr === void 0 ? void 0 : _errors$find$sourceEr.inputs) || (source === null || source === void 0 ? void 0 : source.inputs);
                }
                _context3.next = 7;
                return (0, _priceutils.getPriceExplorerLink)(accessToken, inputs);
              case 7:
                return _context3.abrupt("return", _context3.sent);
              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function getPriceExplorerLink(_x2) {
        return _getPriceExplorerLink2.apply(this, arguments);
      }
      return getPriceExplorerLink;
    }()
  }, {
    key: "getPriceInfo",
    value: function getPriceInfo() {
      var _this$props2 = this.props,
        accessToken = _this$props2.accessToken,
        itemId = _this$props2.itemId,
        priceType = _this$props2.priceType;
      return this.pasLoader.getPriceWithSource(accessToken, itemId, _pricingResource2.priceTypesToPasTypes[priceType]);
    }
  }, {
    key: "verifyPriceCreatePermission",
    value: function () {
      var _verifyPriceCreatePermission = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var uri, stage, _this$state, _this$state$priceInfo, _this$state$priceInfo2, _this$state$priceInfo3, _this$state$priceInfo4, fulfillerName;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                uri = '';
                if (!(this.props.priceType === _pricingResource2.priceTypes.manufacturingCostTypeV1)) {
                  _context4.next = 8;
                  break;
                }
                stage = (0, _priceutils.getFulfillerRoutedStage)(this.state.priceInfo);
                if (stage !== null && stage !== void 0 && stage.seller) {
                  _context4.next = 5;
                  break;
                }
                return _context4.abrupt("return");
              case 5:
                uri = (0, _priceutils.getPriceCreatePermissionUri)(stage.seller.id);
                _context4.next = 12;
                break;
              case 8:
                fulfillerName = (_this$state = this.state) === null || _this$state === void 0 ? void 0 : (_this$state$priceInfo = _this$state.priceInfo) === null || _this$state$priceInfo === void 0 ? void 0 : (_this$state$priceInfo2 = _this$state$priceInfo.priceAssociation) === null || _this$state$priceInfo2 === void 0 ? void 0 : (_this$state$priceInfo3 = _this$state$priceInfo2.seller) === null || _this$state$priceInfo3 === void 0 ? void 0 : (_this$state$priceInfo4 = _this$state$priceInfo3.fulfiller) === null || _this$state$priceInfo4 === void 0 ? void 0 : _this$state$priceInfo4.name;
                if (fulfillerName) {
                  _context4.next = 11;
                  break;
                }
                return _context4.abrupt("return");
              case 11:
                uri = (0, _priceutils.getPriceCreatePermissionUri)(fulfillerName);
              case 12:
                _context4.prev = 12;
                _context4.next = 15;
                return _index["default"].get(uri, {
                  headers: {
                    'Authorization': "Bearer ".concat(this.props.accessToken)
                  }
                });
              case 15:
                this.setState({
                  hasPermissionForPriceRepair: true
                });
                _context4.next = 21;
                break;
              case 18:
                _context4.prev = 18;
                _context4.t0 = _context4["catch"](12);
                if (_context4.t0.response.status === 404) {
                  this.setState({
                    hasPermissionForPriceRepair: false
                  });
                }
              case 21:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[12, 18]]);
      }));
      function verifyPriceCreatePermission() {
        return _verifyPriceCreatePermission.apply(this, arguments);
      }
      return verifyPriceCreatePermission;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props3 = this.props,
        useCurrencySymbol = _this$props3.useCurrencySymbol,
        locale = _this$props3.locale,
        i18n = _this$props3.i18n,
        itemId = _this$props3.itemId,
        repairReason = _this$props3.repairReason,
        priceType = _this$props3.priceType,
        accessToken = _this$props3.accessToken,
        productConfigurationHref = _this$props3.productConfigurationHref;
      var _this$state2 = this.state,
        checking = _this$state2.checking,
        priceInfo = _this$state2.priceInfo,
        showFullJson = _this$state2.showFullJson,
        hasPermissionForPriceRepair = _this$state2.hasPermissionForPriceRepair,
        show = _this$state2.show,
        priceExplorerHref = _this$state2.priceExplorerHref;
      return /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_ItemPriceDiagnosticModal["default"], {
        locale: locale,
        i18n: i18n,
        show: show,
        itemId: itemId,
        repairReason: repairReason,
        priceType: priceType,
        accessToken: accessToken,
        checking: checking,
        priceInfo: priceInfo,
        showFullJson: showFullJson,
        useCurrencySymbol: useCurrencySymbol,
        hasPermissionForPriceRepair: hasPermissionForPriceRepair,
        priceExplorerHref: priceExplorerHref,
        onClickViewJson: function onClickViewJson() {
          return _this3.setState({
            showFullJson: !_this3.state.showFullJson
          });
        },
        onHide: function onHide() {
          return _this3.setState({
            show: false
          });
        },
        onNewPrice: function onNewPrice() {
          return _this3.loadData();
        },
        productConfigurationHref: productConfigurationHref
      }), /*#__PURE__*/_react["default"].createElement(_DiagnosticButton["default"], {
        onClick: function onClick() {
          _this3.setState({
            show: true
          }, function () {
            return _this3.loadData();
          });
        },
        disabled: this.props.disabled,
        tooltipText: this.props.tooltipText || (0, _i18n.tt)(this.props, 'diagnostics:icon_tooltip_view_more_info')
      }, this.props.children));
    }
  }]);
  return ItemPriceDiagnostic;
}(_react.Component);
ItemPriceDiagnostic.propTypes = {
  locale: _propTypes["default"].string,
  itemId: _propTypes["default"].string.isRequired,
  accessToken: _propTypes["default"].string.isRequired,
  priceType: _propTypes["default"].string.isRequired,
  useCurrencySymbol: _propTypes["default"].bool,
  repairReason: _propTypes["default"].string,
  i18n: _propTypes["default"].any,
  // comes from withTranslation
  disabled: _propTypes["default"].bool,
  tooltipText: _propTypes["default"].string,
  children: _propTypes["default"].node,
  pasLoader: _propTypes["default"].instanceOf(_pricingResource.PasLoader),
  productConfigurationHref: _propTypes["default"].string
};
ItemPriceDiagnostic.defaultProps = {
  locale: 'en',
  repairReason: 'Incorrect prices'
};
var _default = (0, _reactI18next.withTranslation)()(ItemPriceDiagnostic);
exports["default"] = _default;